import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { subHours, subWeeks } from 'date-fns';
import { tap } from 'rxjs/operators';
import { Alert } from 'src/app/model/alert';

import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { AkitaMissionHttpService } from '../akita-mission-http.service';
import { MissionsState, MissionsStore } from '../state/missions.store';
import { BehaviorSubject } from 'rxjs';
import { UrlConfig } from '../../model/urlconfig';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class MissionsService extends NgEntityService<MissionsState> implements UrlConfig {

  newIncomingAlerts: BehaviorSubject<Alert[]> = new BehaviorSubject<Alert[]>([]);
  constructor(
    protected store: MissionsStore,
    private missionService: AkitaMissionHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);
    this.webSocketService.getDataStream('Alert')
      .pipe(untilDestroyed(this))
      .subscribe((data: Alert[]) => {
        this.newIncomingAlerts.next(data);
        this.store.upsertMany(data);
      });
  }
  updateEntitiesUrl(newUrl: string): void {
    this.missionService.setEntitiesUrl(newUrl);
  }
  /**
   * Get all missions not older than 12 hours
   */
  // getAllForLast12Hours() {
  //   const currentMissionsNotOlderThan12Hours = `dateCreated>=${getDateHoursBefore(12)}`;
  //   this.missionService.executeQuery(currentMissionsNotOlderThan12Hours, 'Alert', true)
  //     .subscribe(missions => this.store.upsertMany(missions));
  // }

  /**
   *  Get all mission not older than 1 week
   */
  getAllForLast1Week() {
    const currentMissionNotOlerThan1Week = `dateCreated>=${getWeekBefore(1)}`; // Mission not older than 1 week: Testing
    this.missionService.executeQuery(currentMissionNotOlerThan1Week, 'Alert', true)
      .subscribe(missions => this.store.upsertMany(missions));
  }

  getMissionbyId(id: ID) {
    this.missionService.loadById(id, {
      params: {
        options: 'keyValues'
      }
    }).subscribe(mission => this.store.add(mission));
  }

  getMissionByIdObs(id: ID) {
    return this.missionService.loadById(id, {
      params: {
        options: 'keyValues'
      }
    }).pipe(
      tap(mission => this.store.add(mission))
    );
  }

  finishMission(mission: Alert) {
    const validTo = new Date().toISOString();
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    const alert = {
      id: mission.id,
      type: mission.type,
      validTo
    };

    this.missionService
      .update(alert, UpdateActionType.APPEND, options)
      .subscribe(
        data => console.log('Updated Alert', data),
        error => console.log('Error inserting in Hub', error)
      );
  }

  finishMissions(alerts: Alert[]) {
    for (const alert of alerts) {
      this.finishMission(alert);
    }
  }

}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function getDateHoursBefore(before: number) {
  return subHours(new Date(), before).toISOString();
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function getWeekBefore(before: number) {
  return subWeeks(new Date(), before).toISOString();
}
